import React from "react";
import { Edit } from "@mui/icons-material";
import { Colors } from "../../../../constants/Colors";
import { Fleet } from "../../../../types/fleets.types";
import { editVehicleEffect } from "../../../../stores/FleetsStore/FleetsStore.effects";
import FleetFormModal from "../FleetFormModal/FleetFormModal";

interface Props {
  fleet: Fleet;
}

const EditFleet: React.FC<Props> = ({ fleet }) => {
  return (
    <FleetFormModal
      isEdit
      fleet={fleet}
      effect={editVehicleEffect}
      title="Editar frota"
      confirmText="Confirmar"
      cancelText="Cancelar"
      TriggerComponent={
        <Edit
          sx={{
            color: Colors.primary[100],
            ":hover": { opacity: "70%" },
            cursor: "pointer",
          }}
        />
      }
    />
  );
};

export default EditFleet;
